import React, { useEffect, useCallback, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { createSelector } from "reselect";
// Components
import withRouter from "Components/Common/withRouter";
import SidebarMenuItem from "Layouts/SidebarMenuItem";
// Redux
import { useSelector } from "react-redux";
import { getAuthList, getTranslations } from "slices/thunks";
// Import Data
import navdata from "../LayoutMenuData";
// Language, Static Datas and Assets
import { withTranslation } from "react-i18next";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// Helpers and Hooks
import { useGlobalHooks } from "hooks/useGlobalHooks";

const VerticalLayout = (props: any) => {
  const navData = navdata().props.children;
  const { isSidebarOpen } = props;

  const { dispatch } = useGlobalHooks();
  /*
 layout settings
 */
  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      leftsidbarSizeType: layout.leftsidbarSizeType,
      sidebarVisibilitytype: layout.sidebarVisibilitytype,
      layoutType: layout.layoutType,
    })
  );
  // Inside your component
  const { leftsidbarSizeType, sidebarVisibilitytype, layoutType } = useSelector(
    selectLayoutProperties
  );

  const selectLayoutStateAuth = (state: any) => state.Dashboard;
  const selectLayoutPropertiesAuth = createSelector(
    selectLayoutStateAuth,
    (state) => ({
      authData: state.authData,
    })
  );

  const { authData } = useSelector(selectLayoutPropertiesAuth);
  const userRole = authData?.userRoleType || "Partner";

  // Filter menu items based on userRole
  const filteredNavData = navData.filter((item: any) => {
    return item.roles && item.roles.includes(userRole);
  });

  useEffect(() => {
    !authData.length && dispatch(getAuthList());
  }, []);

  const currentLanguage: any = sessionStorage.getItem("I18N_LANGUAGE");

  useEffect(() => {
    if (currentLanguage) {
      dispatch(getTranslations(currentLanguage));
    }
  }, []);

  //vertical and semibox resize events
  const resizeSidebarMenu = useCallback(() => {
    var windowSize = document.documentElement.clientWidth;
    const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
    var hamburgerIcon = document.querySelector(".hamburger-icon");
    if (windowSize >= 993) {
      if (document.documentElement.getAttribute("data-layout") === "vertical") {
        document.documentElement.setAttribute(
          "data-sidebar-size",
          leftsidbarSizeType
        );
      }
      if (document.documentElement.getAttribute("data-layout") === "semibox") {
        document.documentElement.setAttribute(
          "data-sidebar-size",
          leftsidbarSizeType
        );
      }
      if (
        (sidebarVisibilitytype === "show" ||
          layoutType === "vertical" ||
          layoutType === "twocolumn") &&
        document.querySelector(".hamburger-icon")
      ) {
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.remove("open");
        }
      } else {
        // var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.add("open");
        }
      }
    } else if (windowSize <= 992) {
      document.body.classList.remove("vertical-sidebar-enable");
      if (
        document.documentElement.getAttribute("data-layout") !== "horizontal"
      ) {
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
      if (humberIcon) {
        humberIcon.classList.add("open");
      }
    }
  }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

  useEffect(() => {
    window.addEventListener("resize", resizeSidebarMenu, true);
  }, [resizeSidebarMenu]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
      const ul: any = document.getElementById("navbar-nav");
      const items = ul.getElementsByTagName("a");
      let itemsArray = [...items]; // converts NodeList to Array
      removeActivation(itemsArray);
      let matchingMenuItem = itemsArray.find((x) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    if (props.layoutType === "vertical") {
      initMenu();
    }
  }, [props.router.location.pathname, props.layoutType]);

  function activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute(
        "aria-expanded",
        "true"
      );
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement
          .closest(".collapse")
          .classList.add("show");
        if (
          parentCollapseDiv.parentElement.closest(".collapse")
            .previousElementSibling
        )
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.classList.add("active");
        if (
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.closest(".collapse")
        ) {
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.closest(".collapse")
            .classList.add("show");
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.closest(".collapse")
            .previousElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items: any) => {
    let actiItems = items.filter((x: any) => x.classList.contains("active"));

    actiItems.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  };

  return (
    <React.Fragment>
      {(filteredNavData || []).map((item: any, key: any) => {
        const isOpen = item.stateVariables;

        return (
          <React.Fragment key={`language-menu-${item.id}`}>
            {item.subItems && item.subItems?.length > 0 ? (
              <div className="nav-item">
                <Link
                  // onClick={item.click}
                  onMouseEnter={item.click}
                  className={`nav-link menu-link ${item.id === "account" ? "mb-5" : ""}`}
                  to={item.link ? item.link : "/#"}
                  data-bs-toggle="collapse"
                >
                  <div className="without-arrow">
                    <small className="menu-icon">{item.icon}</small>
                    {isSidebarOpen ? (
                      <span data-key="t-apps">
                        {item.id === "account"
                          ? `${
                              authData.partnerNameOriginal &&
                              authData.partnerSurnameOriginal
                                ? `${authData.partnerNameOriginal} ${authData.partnerSurnameOriginal}`
                                : authData.displayName || ""
                            }`
                          : props.t(item.label)}
                      </span>
                    ) : (
                      !item.stateVariables && (
                        <span data-key="t-apps">
                          {item.id === "account"
                            ? `${
                                authData.partnerNameOriginal &&
                                authData.partnerSurnameOriginal
                                  ? `${authData.partnerNameOriginal} ${authData.partnerSurnameOriginal}`
                                  : authData.displayName || ""
                              }`
                            : props.t(item.label)}
                        </span>
                      )
                    )}
                  </div>
                  <span className="menu-icon-arrow">
                    {props.dir === "rtl" ? (
                      <IoIosArrowBack />
                    ) : (
                      <IoIosArrowForward />
                    )}
                  </span>
                </Link>

                <div className={`offcanvas-container ${isOpen ? "open" : ""}`}>
                  <div
                    className="offcanvas-backdrop"
                    onClick={item.click}
                    onMouseEnter={isOpen ? item.click : undefined}
                  ></div>

                  <div className="offcanvas-sidebar">
                    <button
                      className="offcanvas-close-button"
                      onClick={item.click}
                    >
                      x
                    </button>

                    <div className="offcanvas-content">
                      <h3 className="sidebar-sub-menu-title">{item.label}</h3>

                      <SidebarMenuItem
                        subItems={item.subItems}
                        isAccountMenu={item.id === "account"}
                        handleClick={item.click}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="nav-item"
                onClick={item.click}
                onMouseEnter={item.click}
              >
                <Link
                  className="nav-link menu-link"
                  to={item.link ? item.link : "/#"}
                >
                  <div className="without-arrow">
                    <small className="menu-icon">{item.icon}</small>
                    <span>{props.t(item.label)}</span>
                  </div>
                </Link>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));
